/**
 * Created by Bart Decorte
 * Date: 14/09/2021
 * Time: 10:37
 */
import UploadPreviewListItem from './UploadPreviewListItem';

export default class UploadPreviewListItemImage extends UploadPreviewListItem {
  constructor(rootEl, params = {}) {
    super(rootEl, params);
  }

  async renderMiniature() {
    const dataUrl = await this.miniatureSource();

    // TODO binding to the onload event on object creation would make it possible to make the miniature element
    // invisible for preview items of "old input" images as well. These have a regular URL in their src attribute
    // instead of a base64 URL
    this.miniatureEl().onload = () => {
      this.miniatureEl().classList.remove('invisible');
    };

    this.miniatureEl().src = dataUrl;
  }

  renderMiniatureAlt() {
    this.miniatureEl().alt = this.file.name;
  }

  miniatureEl() {
    return this.rootEl.querySelector('.js-upload__miniature');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreviewListItemImage.js